import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classnames from 'classnames';

import Icon from 'components/Icon';
import './Logo.less';

const Logo = props => {
  const { logoImg, href, title, color, size, isResponsive } = props;

  const classes = classnames('Logo__svgTitle', `Logo__svgTitle--${size}`, {
    'Logo__svgTitle--responsive': isResponsive,
  });

  const accessibleTitle = `Rakuten Advertising${title ? ` - ${title}` : ''}`;

  const logo = (
    <Fragment>
      {logoImg || (
        <Fragment>
          {isResponsive && (
            <Icon
              type="rakuten"
              title={accessibleTitle}
              className={`Logo__svgIcon Logo__svgIcon--${color}`}
            />
          )}

          <svg
            viewBox="0 0 340 42"
            className={classes}
            aria-labelledby="RakutenLogoTitle"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="RakutenLogoTitle">{accessibleTitle}</title>
            <g fill="none" fillRule="evenodd">
              <path d="M-11.2 48.9c-1.6 0-2.8-1.3-2.8-2.8V-9.2c0-1.5 1.3-2.8 2.8-2.8h362.3c1.6 0 2.8 1.3 2.8 2.8v55.3c0 1.6-1.3 2.8-2.8 2.8H-11.2z" />
              <path d="M.2 2.2h339.6v32.6H.2z" />
              <g fillRule="nonzero">
                <path d="M111.4 34.8H27.8l6.7 6.6zM35.6 7.8v1c-1.6-1-2.9-1.6-4.9-1.6-5.9 0-10.3 5.3-10.3 11.9 0 6.6 4.5 11.9 10.3 11.9 1.9 0 3.3-.6 4.9-1.6v1h5.1V7.8h-5.1zm-4.9 17.8c-2.9 0-5-2.8-5-6.4 0-3.6 2.1-6.4 5-6.4s4.9 2.8 4.9 6.4c0 3.6-2 6.4-4.9 6.4zM76.8 7.8v13.3c0 2.5-1.7 4.6-4.2 4.6s-4.2-2.1-4.2-4.6V7.8h-5.2v13.3c0 5.5 3.7 9.9 9.2 9.9 2.5 0 4.4-1.4 4.4-1.4v.8H82V7.8h-5.2zM124.8 30.5V17.2c0-2.5 1.7-4.6 4.2-4.6s4.2 2.1 4.2 4.6v13.3h5.2V17.2c0-5.5-3.7-9.9-9.2-9.9-2.5 0-4.4 1.4-4.4 1.4v-.8h-5.2v22.7h5.2v-.1z" />
                <path d="M5.6 30.5v-8.8h3.8l6.6 8.8h6.7l-8-10.6c2.5-1.8 4.1-4.7 4.1-8 0-5.4-4.4-9.8-9.8-9.8H.1v28.3h5.5v.1zm0-22.9h3.5c2.4 0 4.4 2 4.4 4.4 0 2.4-2 4.4-4.4 4.4H5.6V7.6zM95.9 25.2c-.5.3-1 .6-1.7.6-.8 0-2.4-.6-2.4-2.8v-9.7h4.4V7.9h-4.4V2.2h-5.2v5.7h-2.7v5.4h2.7V23c0 5.1 3.8 8.1 7.7 8.1 1.4 0 3.4-.5 5-1.4l-3.4-4.5zM53.5 18.5l8.9-10.7h-7.3L49 15.7V.3h-5.3v30.2H49v-9.3l7.5 9.3h7.3z" />
                <path d="M107.7 7.3c-6 0-10.2 5.2-10.2 11.9 0 7 5.4 11.9 10.7 11.9 2.7 0 6.2-.9 9.1-5.1l-4.5-2.6c-3.5 5.2-9.4 2.6-10.1-2.6h14.8c1.4-8.2-3.9-13.5-9.8-13.5zm4.5 8.9H103c1.1-5.3 8.2-5.6 9.2 0z" />
                <g>
                  <path d="M146.3 30.5l10-26.9h4.1l10 26.9h-3.7l-2.4-6.7h-12.1l-2.4 6.7h-3.5zm7-9.9h9.8l-4.9-13.8-4.9 13.8zM179.7 30.9c-1.8 0-3.4-.5-4.8-1.4-1.4-1-2.6-2.3-3.4-4-.8-1.7-1.2-3.6-1.2-5.8 0-2.2.4-4.1 1.2-5.8.8-1.7 2-3 3.4-3.9 1.4-1 3-1.4 4.8-1.4 1.6 0 3.1.4 4.3 1.2 1.3.8 2.2 1.9 2.9 3.2V.6h3.4v30h-2.9l-.4-4.1c-.6 1.4-1.6 2.4-2.9 3.2-1.3.8-2.8 1.2-4.4 1.2zm.6-3.3c1.3 0 2.4-.3 3.4-1s1.8-1.6 2.4-2.8c.6-1.2.9-2.6.9-4.1 0-1.6-.3-3-.9-4.1-.6-1.2-1.4-2.1-2.4-2.8-1-.7-2.1-1-3.4-1-1.3 0-2.4.3-3.4 1s-1.8 1.6-2.4 2.8c-.6 1.2-.9 2.6-.9 4.1 0 1.5.3 2.9.9 4.1.6 1.2 1.4 2.1 2.4 2.8 1 .7 2.1 1 3.4 1zM200.7 30.5L192.5 9h3.8l6.6 17.8L209.4 9h3.5l-8.3 21.5zM222.7 31c-2.1 0-3.8-.5-5.4-1.4-1.5-.9-2.7-2.3-3.5-3.9-.8-1.7-1.2-3.6-1.2-5.9 0-2.2.4-4.2 1.2-5.9.8-1.7 2-3 3.4-4s3.1-1.5 5-1.5 3.5.5 5 1.5c1.4 1 2.6 2.3 3.4 4 .8 1.7 1.2 3.6 1.2 5.9v.8H216c.1 2.4.8 4.2 2.1 5.4 1.2 1.2 2.9 1.8 4.9 1.8 2.6 0 4.7-1.3 6.4-3.8l2.2 2.4c-1 1.4-2.3 2.6-3.8 3.4-1.6.8-3.3 1.2-5.1 1.2zm-.4-19.3c-1.7 0-3 .5-4.1 1.6-1.1 1.1-1.7 2.6-2 4.5h12.2c-.3-1.9-1-3.5-2-4.5-1.1-1.1-2.5-1.6-4.1-1.6zM234.5 30.5V9h2.9l.4 4.1c.6-1.4 1.4-2.5 2.4-3.3 1-.8 2.2-1.2 3.5-1.2 1.4 0 2.7.5 3.8 1.4l-1.2 3.4c-1-.8-2-1.2-3-1.2s-1.9.3-2.7 1c-.8.7-1.5 1.6-1.9 2.7-.5 1.1-.7 2.4-.7 3.8v10.9h-3.5v-.1zM259.3 30.9c-4.2 0-6.2-2.4-6.2-7.3V12.1h-3.8V9h3.8V3.4h3.4V9h7.5v3.1h-7.5v11.4c0 2.8 1.1 4.1 3.2 4.1.6 0 1.3-.1 1.8-.4.6-.2 1.2-.6 1.9-1.2l1 3.3c-1.4 1.1-3.1 1.6-5.1 1.6zM269.1 5.7c-.7 0-1.3-.2-1.8-.7-.5-.5-.7-1.1-.7-1.7 0-.6.2-1.2.7-1.7.5-.5 1-.7 1.8-.7.7 0 1.3.2 1.8.7.5.5.7 1.1.7 1.7 0 .6-.2 1.2-.7 1.7-.5.5-1.1.7-1.8.7zm-1.7 24.8V9h3.4v21.5h-3.4zM281.8 31c-1.8 0-3.4-.4-4.9-1.1-1.5-.8-2.7-1.9-3.8-3.3l2.2-2.5c1.6 2.5 3.7 3.8 6.4 3.8 1.4 0 2.4-.3 3.2-.8.8-.5 1.1-1.3 1.1-2.2 0-1.7-1.2-2.8-3.7-3.5l-2.5-.6c-1.7-.5-3.1-1.2-4.1-2.3-1-1.1-1.5-2.3-1.5-3.8 0-1.2.3-2.3 1-3.2.6-.9 1.5-1.7 2.6-2.2 1.1-.5 2.3-.8 3.7-.8 1.5 0 2.9.3 4.2.9 1.3.6 2.3 1.5 3.1 2.7l-2.1 2.5c-.8-1.1-1.5-1.8-2.3-2.3-.8-.5-1.8-.7-2.8-.7-1.1 0-2.1.3-2.8.8-.7.5-1.1 1.2-1.1 2.1 0 .8.3 1.4.8 1.9.6.5 1.5.9 2.9 1.3l2.4.6c1.8.5 3.2 1.3 4.2 2.4 1 1.1 1.5 2.4 1.5 3.9 0 1.9-.7 3.4-2.1 4.6-1.4 1.2-3.3 1.8-5.6 1.8zM293.9 5.7c-.7 0-1.3-.2-1.8-.7-.5-.5-.7-1.1-.7-1.7 0-.6.2-1.2.7-1.7.5-.5 1-.7 1.8-.7.7 0 1.3.2 1.8.7.5.5.7 1.1.7 1.7 0 .6-.2 1.2-.7 1.7-.5.5-1.1.7-1.8.7zm-1.7 24.8V9h3.4v21.5h-3.4zM299.3 30.5V9h2.9l.4 4c.7-1.4 1.7-2.5 2.9-3.2 1.2-.8 2.6-1.2 4.2-1.2 2.3 0 4.2.8 5.6 2.4 1.4 1.6 2.1 4 2.1 7.1v12.4H314V18.3c0-2.1-.5-3.7-1.4-4.8-.9-1.1-2.1-1.6-3.7-1.6-1.2 0-2.3.3-3.2 1-.9.7-1.7 1.5-2.2 2.6-.5 1.1-.8 2.3-.8 3.6v11.4h-3.4zM329.6 39c-1.8 0-3.5-.3-5.1-.9-1.6-.6-3-1.4-4.1-2.5l1.3-3.1c1.1 1 2.3 1.8 3.6 2.4 1.3.5 2.7.8 4.2.8 4.6 0 6.9-2.7 6.9-8.2V26c-.7 1.3-1.6 2.3-2.9 3.2-1.3.8-2.7 1.3-4.2 1.3-1.8 0-3.4-.5-4.8-1.4-1.4-.9-2.5-2.2-3.3-3.9-.8-1.6-1.2-3.5-1.2-5.6 0-2.1.4-4 1.2-5.7.8-1.7 1.9-3 3.3-3.9 1.4-1 3-1.4 4.8-1.4 1.6 0 3 .4 4.3 1.2 1.3.8 2.3 1.9 2.9 3.1l.3-3.9h2.9v18.6c0 3.8-.9 6.6-2.7 8.6-1.7 1.9-4.2 2.8-7.4 2.8zm.3-11.8c1.3 0 2.4-.3 3.4-1s1.8-1.6 2.3-2.7c.6-1.2.8-2.5.8-4s-.3-2.9-.8-4c-.6-1.2-1.3-2.1-2.3-2.7-1-.6-2.1-1-3.4-1-1.3 0-2.4.3-3.4 1-1 .6-1.7 1.5-2.3 2.7-.6 1.2-.8 2.5-.8 4s.3 2.9.8 4c.6 1.2 1.3 2.1 2.3 2.7 1 .7 2.1 1 3.4 1z" />
                </g>
              </g>
            </g>
          </svg>
        </Fragment>
      )}

      {title && (
        <span
          className={`Logo__customTitle Logo__customTitle--${color} Logo__customTitle--${size}`}
          role="presentation"
          aria-hidden
        >
          {title}
        </span>
      )}
    </Fragment>
  );

  if (href)
    return (
      <a className={`Logo Logo--${color}`} href={href}>
        {logo}
      </a>
    );

  return <div className={`Logo Logo--${color}`}>{logo}</div>;
};

Logo.propTypes = {
  /**
   * Element used for the Logo itself. If left empty then default Rakuten Advertising logo is displayed.
   */
  logoImg: PropTypes.node,

  /**
   * Logo link destination
   */
  href: PropTypes.string,

  /**
   * If passed in, this add an additional custom site title
   * after the default Rakuten Advertising logo
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /**
   * Logo color
   */
  color: PropTypes.oneOf(['white', 'purple', 'black']),

  /**
   * Logo size
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),

  /**
   * Determines whether the logo changes to icon in smaller breakpoints.
   */
  isResponsive: PropTypes.bool,

  /**
   * Deprecating. Use color or size prop variants
   *
   * @deprecated v4
   */
  // eslint-disable-next-line react/no-unused-prop-types
  className: PropTypes.string,
};

Logo.defaultProps = {
  logoImg: null,
  href: null,
  title: null,
  color: 'white',
  size: 'sm',
  isResponsive: true,
  /**
   * Deprecating. Use color or size prop variants
   *
   * @deprecated v4
   */
  className: '',
};

export default Logo;
